import {useUpmPlantsContext} from '@hconnect/upm'
import {FilterSelectProps, FilterSelect} from '@widgets/common-filters'

import {useUserPlantList} from '../../hooks'

type PlantFilterProps<TName extends string> = Omit<FilterSelectProps<string, TName>, 'options'> & {
  allowedPlantUpmIds?: string[]
}

export const PlantFilter = <TName extends string>({
  allowedPlantUpmIds,
  ...props
}: PlantFilterProps<TName>) => {
  const allPlants = useUserPlantList()
  const upmPlants = useUpmPlantsContext()

  const plants = allowedPlantUpmIds
    ? allPlants.filter(({plantId}) => {
        const upmPlant = upmPlants[plantId]
        return upmPlant && allowedPlantUpmIds.includes(upmPlant.upmId)
      })
    : allPlants

  const options = plants.map(({plantId, plantName}) => ({
    value: plantId,
    label: plantName
  }))

  return <FilterSelect {...props} options={options} />
}
